import { Alert, Button, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import type { AdvisorFeeReminder } from "./pipelineCellSave";

type PipelineFeeReminderProps = {
  reminder: AdvisorFeeReminder | null;
  onDismiss: () => void;
};

/** Shown after a row is saved into closing without advisor fee quotes. */
export function PipelineFeeReminder({
  reminder,
  onDismiss,
}: PipelineFeeReminderProps) {
  const navigate = useNavigate();

  return (
    <Snackbar
      open={reminder != null}
      autoHideDuration={12_000}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      onClose={(_event, reason) => {
        if (reason !== "clickaway") onDismiss();
      }}
    >
      <Alert
        severity="warning"
        variant="filled"
        onClose={onDismiss}
        action={
          reminder?.dealId != null ? (
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                onDismiss();
                navigate(`/deals/${reminder.dealId}?tab=advisorFees`);
              }}
            >
              Add fees
            </Button>
          ) : undefined
        }
      >
        {reminder && (
          <>
            <strong>{reminder.dealName}</strong> is now in closing. Please add
            advisor fee quotes for {reminder.missing.join(", ")}.
          </>
        )}
      </Alert>
    </Snackbar>
  );
}
